import {createPoint, buildGeometryInstance, handleAddCorrectnessIcon} from './entities.utils';

const point = {
  /**
   * @example
   * const entity = {
   *   type: "point",
   *   elements: {
   *     point: [1, 2]
   *   },
   *   flavor: 'studentGuess'
   * };
   */
  create({board, entity, onClick}) {
    const {
      flavor,
      elements: {point: pointCoords}
    } = entity;

    const point = createPoint({
      board,
      coords: pointCoords,
      flavor
    });

    const correctnessIcon = handleAddCorrectnessIcon({board, flavor, coords: pointCoords});

    return buildGeometryInstance({
      board,
      entity,
      geometryElement: point,
      constituentElements: [point],
      onClick,
      correctnessIcon
    });
  },
  createPartial({board, partialInstance, coords, flavor}) {
    if (!partialInstance) {
      return {
        entity: {
          type: 'point',
          elements: {
            point: null
          },
          flavor
        },
        geometryElements: [],
        done: false,
        instructions: 'Plot a point on the graph below.',
        remove() {
          return null;
        }
      };
    }

    const point = createPoint({board, coords, flavor});
    return {
      entity: {
        type: 'point',
        elements: {
          point: coords
        },
        flavor
      },
      geometryElements: [point],
      done: true,
      remove() {
        board.removeAncestors(point);
        return null;
      }
    };
  }
};

export default point;
